import {FC} from "react"

import {TooltipWrapper} from "@frontend/components/ui/tooltip"
import electricityIcon from "@frontend/design/icons/caution-electricity.svg"
import fireIcon from "@frontend/design/icons/caution-fire.svg"
import heavyCautionIcon from "@frontend/design/icons/caution-heavy.svg"
import waterIcon from "@frontend/design/icons/caution-water.svg"
import {useTranslation} from "@frontend/i18n"
import type {DiyStepCaution} from "@ri2/db/client"
import {css, cx} from "@styled-system/css"

const ICONS: Record<DiyStepCaution, string> = {
  FIRE: fireIcon,
  ELECTRICITY: electricityIcon,
  WATER: waterIcon,
  SHARP: waterIcon,
  HEAVY: heavyCautionIcon,
  HOT: waterIcon,
  FRAGILE: waterIcon,
  SPILL: waterIcon,
}

interface Props {
  caution: DiyStepCaution
  className?: string
}

export const CautionIcon: FC<Props> = ({caution, className}) => {
  const t = useTranslation()
  const name = t(`cause.diy.guide.caution.${caution}`)
  const label = t("cause.diy.guide.caution.label", {name})

  return (
    <TooltipWrapper content={label} positioning="top" variant="dark" inline>
      <span
        aria-label={label}
        className={cx(
          css({
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            borderRadius: 4,
            backgroundColor: "bgRed",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "border.error",
            flexShrink: 0,
            verticalAlign: "middle",
            cursor: "default",
          }),
          className,
        )}
      >
        <img
          src={ICONS[caution]}
          alt=""
          className={css({height: 12, width: 12})}
        />
      </span>
    </TooltipWrapper>
  )
}
